var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],attrs:{"pill":""},on:{"click":_vm.onClick}},[_c('b-icon-chevron-bar-up')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }